import React from 'react';

/**
 * Renders action buttons to change user status (activate, deactivate, block, unblock).
 */
const UserStatusActions = ({ user, onStatusChange }) => {
  if (!user || !onStatusChange) return null;

  const { status, _id } = user;

  switch (status) {
    case 'active':
      return (
        <>
          <button
            type="button"
            onClick={() => onStatusChange(_id, 'inactive')}
            className="px-2 py-1 bg-yellow-100 text-yellow-700 rounded-md text-xs hover:bg-yellow-200"
            title="Mark as Inactive"
          >
            Deactivate
          </button>
          <button
            type="button"
            onClick={() => onStatusChange(_id, 'blocked')}
            className="px-2 py-1 bg-red-100 text-red-700 rounded-md text-xs hover:bg-red-200 ml-1"
            title="Block User"
          >
            Block
          </button>
        </>
      );
    case 'inactive':
      return (
        <>
          <button
            type="button"
            onClick={() => onStatusChange(_id, 'active')}
            className="px-2 py-1 bg-green-100 text-green-700 rounded-md text-xs hover:bg-green-200"
            title="Mark as Active"
          >
            Activate
          </button>
          <button
            type="button"
            onClick={() => onStatusChange(_id, 'blocked')}
            className="px-2 py-1 bg-red-100 text-red-700 rounded-md text-xs hover:bg-red-200 ml-1"
            title="Block User"
          >
            Block
          </button>
        </>
      );
    case 'blocked':
      return (
        <button
          type="button"
          onClick={() => onStatusChange(_id, 'active')}
          className="px-2 py-1 bg-green-100 text-green-700 rounded-md text-xs hover:bg-green-200"
          title="Unblock User"
        >
          Unblock
        </button>
      );
    default:
      return null;
  }
};

export default UserStatusActions;
